export const columnas = [
  { id: "idSolicitud", label: "ID", isNumeric: true },
  { id: "fecha", label: "Fecha", type: "date" },
  { id: "usuario_username", label: "Usuario" },
  { id: "usuario_perfil_nombre", label: "Nombre" },
  { id: "usuario_perfil_apellido", label: "Apellido" },
  { id: "usuario_segmento_descripcion", label: "Segmento" },
  { id: "beneficio_nombre", label: "Beneficio" },
  {
    id: "beneficio_rubros",
    label: "Rubro",
    type: "array",
    field: "descripcion"
  },
  { id: "beneficio_idTipo_tipo", label: "Tipo beneficio" }
];

export const misColumnas = [
  { id: "idSolicitud", label: "ID", isNumeric: true },
  { id: "fecha", label: "Fecha", type: "date" },
  { id: "beneficio_nombre", label: "Beneficio" },
  {
    id: "beneficio_rubros",
    label: "Rubro",
    type: "array",
    field: "descripcion"
  },
  { id: "beneficio_idTipo_tipo", label: "Tipo beneficio" },
  { id: "actions", label: "Acciones" }
];
